import LtFramework from '../../../types/lt/ltFramework';

export default class StorageService implements LtFramework.IStorageService {
	public get<T>(key: string): string | T {
		let value: string | T = window.sessionStorage.getItem(key) as string;
		if (value) {
			value = JSON.parse(value) as T;
		}

		return value;
	}

	public set<T>(key: string, localData: T): void {
		const value: string = JSON.stringify(localData);
		window.sessionStorage.setItem(key, value);
	}

	public remove(key: string): void {
		window.sessionStorage.removeItem(key);
		if (window.sessionStorage.getItem(key)) {
			window.sessionStorage.setItem(key, '');
		}
	}
}

export const storageService = new StorageService();
